module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-box-lang",
    attrs: {
      "id": "lang-login"
    }
  }, [_vm._l((_vm.allLang), function(value, index) {
    return [_c('img', {
      staticClass: "img-language position-flag cursor-pointer",
      attrs: {
        "src": require('../../assets/img/login/flag_' + _vm.focusLang(value) + '.png')
      },
      on: {
        "click": function($event) {
          _vm.setLang(value)
        }
      }
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f0cdc8e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/langLogin.vue
// module id = 3749
// module chunks = 1